module.exports = __webpack_public_path__ + "static/media/taxfiling_banner.015a2965.svg";